import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrCallbackTimeSlot.ts
var t = () => e("callbackTimeSlot");
//#endregion
export { t as useTrCallbackTimeSlot };
